import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { AuswertungenService } from '../../auswertungen.service';
import { loadZeitFailed, loadZeitStart, loadZeitSucceeded } from '../actions/Zeit-output.actions';
import {getFilteredZeitFailed, getFilteredZeitStarted, getFilteredZeitSucceeded
} from '../actions/filter-seek-date.actions';
import {
  loadProjektauswahlNodesFailed,
  loadProjektauswahlNodesStart,
  loadProjektauswahlNodesSucceeded
} from '../actions/getProjektauswahlNodes.actions';

@Injectable()
export class AuswertungenEffects {

  /**
   * Loads the parts of the time table and lists when dispatching the start action
   */
  public loadZeit$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadZeitStart),
      mergeMap(() =>
        this.dS.getAll().pipe(
          map((response) => loadZeitSucceeded({ item: response.data })),
          catchError((e) => of(loadZeitFailed(e))),
        ),
      ),
    ),
  );


  /* Such-und Datumswert nach Joel */
  public loadFilteredProjekte$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getFilteredZeitStarted),
      mergeMap((projekt) =>
        this.dS.getFilteredSeekDate(projekt.item).pipe(
          mergeMap((response) => of(getFilteredZeitSucceeded({ item: response.data}))),
          catchError((e) => of(getFilteredZeitFailed(e))),
        ),
      ),
    ),
  );

  /* Such-und Datumswert nach Joel */
  public loadNodes = createEffect(() =>
    this.actions$.pipe(
      ofType(loadProjektauswahlNodesStart),
      mergeMap(() =>
        this.dS.getProjektauswahlNodes().pipe(
          mergeMap((response) => of(loadProjektauswahlNodesSucceeded({ item: response.data}))),
          catchError((e) => of(loadProjektauswahlNodesFailed(e))),
        ),
      ),
    ),
  );


  /**
   * Constructor of Zeit effects
   *
   * @param actions$ - The action observable
   * @param dS = DummyService - The Zeit service
   */
  constructor(private actions$: Actions, private dS: AuswertungenService) {}
}
